/**
 * Discriminator for `PatientInvoice` ownership semantics (TM-9064):
 *
 * - `THERAPY`: the spine's regular per-unit invoice — lines reference
 *   `TreatmentUnit` rows and consolidate per the partition rules.
 * - `CANCELLATION_FEE`: a standalone Schadensersatz invoice that charges a
 *   single `CancellationFee`. Never consolidated with therapy lines; never
 *   tied to a `TreatmentUnit`. The line is nicht-steuerbarer Schadensersatz
 *   (rate 0, taxType `Nicht steuerbar (Schadensersatz)`).
 */
export var InvoiceKind;
(function (InvoiceKind) {
    InvoiceKind["THERAPY"] = "therapy";
    InvoiceKind["CANCELLATION_FEE"] = "cancellation_fee";
})(InvoiceKind || (InvoiceKind = {}));
/**
 * Tax-type marker used on `CANCELLATION_FEE` invoice lines. Matches the
 * accounting treatment documented in
 * `docs/datev-export/Musterverfahrensdokumentation.md` for Mahngebühren:
 * nicht-steuerbarer Schadensersatz, deliberately not the §4 Nr. 14 therapy
 * Steuerbefreiung. DATEV mapping is the HITL child #859.
 */
export const SCHADENSERSATZ_TAX_TYPE = 'Nicht steuerbar (Schadensersatz)';
//# sourceMappingURL=invoice-kind.enum.js.map